import React from "react";
import config from "config";
import RequestUtils from "utils/RequestUtils";

class IComponent extends React.Component {
  constructor() {
    super();
    this.$config = config;

    !window.$config && (window.$config = config);
  }
  createElement() {
    return React.createElement.apply(this, arguments);
  }
  createRef() {
    return React.createRef();
  }

  /**
   * Make HTTP request with XMLHttpRequest. See utils/RequestUtils for detail.
   * @param {*} url
   * @param {*} method
   * @param {*} bodyInJson
   * @param {*} forCredential
   * @returns Promise
   */
  async makeHttpQuery(url, method, bodyInJson, forCredential) {
    return RequestUtils.makeHttpQuery.apply(this, arguments);
  }
  /**
   * Make HTTP request with fetch API. See utils/RequestUtils for detail.
   * @param {*} url
   * @param {*} method
   * @param {*} queryPara
   * @param {*} queryOption
   * @returns Promise
   */
  async fetchQueryMain(
    url,
    method,
    queryPara = null,
    queryOption = {},
    contentType
  ) {
    return RequestUtils.fetchQueryMain.apply(this, arguments);
  }
  /**
   * Make HTTP GET request with fetch API. See utils/RequestUtils for detail.
   * @param {*} url
   * @returns Promise
   */
  async fetchQueryByGET(url) {
    return RequestUtils.fetchQueryByGET.apply(this, arguments);
  }
  /**
   * Make HTTP POST request with fetch API. See utils/RequestUtils for detail.
   * @param {*} url
   * @param {*} queryPara
   * @returns Promise
   */
  async fetchQueryByPOST(url, queryPara) {
    return RequestUtils.fetchQueryByPOST.apply(this, arguments);
  }
  async nativeFeatureLayerQuery(layerObj, queryPara) {
    return RequestUtils.nativeFeatureLayerQuery.apply(this, arguments);
  }
}

export default IComponent;
